import router from "@/router";
import { PushOptions, RouteNameLiteral } from "@/router/types";

export function useTypedRouter() {
    function typedPush<T extends RouteNameLiteral>(options: PushOptions<T>) {
        return router.push(options);
    }

    function typedReplace<T extends RouteNameLiteral>(options: PushOptions<T>) {
        return router.replace(options);
    }

    return {
        ...router,
        push: typedPush,
        replace: typedReplace
    };
}
